export default __webpack_public_path__ + "static/media/Petsupplies.d460cdb4.svg";